"use client";

import { createAuthClient } from "better-auth/react";

/**
 * Browser-side client. With no baseURL it talks to /api/auth on whatever
 * origin the page was served from, so the same build works on production,
 * www and dev without per-environment config.
 */
export const authClient = createAuthClient();

export const { signIn, signUp, signOut, useSession } = authClient;
